import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Start every page at the top. Without this a visitor who was scrolled down a
 * long scoreboard lands at the footer of the game they just opened, because the
 * browser keeps the scroll position across a client-side route change.
 * Changing only the query string (a tab switch) keeps the position.
 */
export function useScrollReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);
}
